/* eslint-disable no-nested-ternary */
/* eslint-disable max-lines-per-function */
/* eslint-disable prefer-template */
import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import tw, { styled } from 'twin.macro';
import { Button } from './button';
import Modal from './modal';

const ModalWrapperBackdrop = styled.div`
  ${tw`fixed top-0 left-0 flex items-center justify-center w-screen h-screen md:p-8 overflow-hidden bg-black cursor-pointer bg-opacity-80`};
  z-index: 1005;

  > div {
    ${tw`invisible opacity-0`};
  }
  @media (max-width: 512px) {
    ${tw`px-0`}
  }
`;

const ModalWrapperContainer = styled.div`
  ${tw`relative w-full cursor-auto`};
  transition: visibility 800ms, opacity 800ms;
  background: transparent;

  ${(props) =>
    props.fitHeight &&
    `
    height: fit-content;
  `}

  &.open {
    ${tw`visible opacity-100`};
  }
  @media (max-width: 578px) {
    ${(props) =>
      props.mobileBottom &&
      `
       height: 0px;
      overflow-y: auto;
    `}
  }
  @media (min-width: 475px) {
    width: ${(props) => (props.width ? `${props.width}%` : null)};

    ${(props) =>
      props.maxWidth &&
      `
      width: ${props.width ? `${props.width}%` : null};
      max-width: ${`${props.maxWidth}px`};
    `}
  }
`;

const ScrollingContainer = styled.div`
  ${tw`w-full overflow-y-auto rounded-md`};
  padding: ${(props) => props.padding ? props.padding : '0rem'};
  background: ${(props) => props.background};
  max-height: 90vh;

  ${({ isOverFlow }) =>
    isOverFlow &&
    `
  overflow-y:hidden;
  @media (max-width: 512px) {
    overflow-y: hidden !important;
     max-height:fit-content; !important;
  }
  `}
  &.open {
    ${tw`visible opacity-100`};
  }

  ${(props) =>
    props.basic &&
    `
    background: transparent;
  `}

  @media (min-width: 820px) and (max-width: 1200px) {
    padding:8px;
  }

  @media (max-width: 768px) {
    padding: ${(props) => (props.padding ? 'calc(' + props.padding + ' / 2)' : null)};
  }

  @media (max-width: 512px) {
    padding: 2px 0;
    overflow-y: auto;
    &::-webkit-scrollbar {
      -webkit-appearance: none;
    }
  }
`;

const ModalWrapperBody = styled.div`
  .close-icon {
    ${tw`absolute top-8`};
    right: ${(props) => (props.basic ? '4rem' : '2rem')};
  }

  .close-icon .icon {
    font-size: 1.25rem;
  }

  @media (max-width: 578px) {
    ${(props) =>
      props.mobileBottom &&
      `
     bottom: 0;
     position: fixed;
     left: 0;
     height: 82.5vh;
     background: white;
     width: 100vw;
     animation: 1.3s slide-up;
     @keyframes slide-up {
      from {    
        height: 0;
      }
      to {
        height: 82.5vh;
      }
    }
     .close-icon{
        display: none
     }
     .wrapper{
       height: 100%;
       overflow-y: auto;
     }
    `}
  @media (max-width: 768px) {
    .close-icon {
      ${tw`top-4`};
      right: ${(props) => (props.basic ? '2rem' : '1rem')};
    }
  }
`;

const CloseButton = styled.button`
  display: none;
  @media (max-width: 578px) {
    ${tw`p-1 absolute text-center text-white flex justify-center items-center border-none`}
    background: rgba(0, 147, 182, 1);
    height: 30px;
    top: -30px;
    display: block;
    width: 30px;
    z-index: 99999;
    left: 0;
    & span {
      color: white;
    }
  }
`;

const ModalWrapper = ({
  mobileBottom,
  redCloseBtn,
  isOverFlow,
  background,
  closeModal,
  fitHeight,
  maxWidth,
  children,
  padding,
  width,
  basic,
  hide,
}) => {
  const [open, setOpen] = useState(false);
  const modalRef = useRef(null);
  const lastActiveElement = useRef(null);

  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (e.target === modalRef.current?.parentNode) {
        closeModal();
        lastActiveElement.current?.focus();
      }
    };

    window.addEventListener('click', handleOutsideClick);

    setTimeout(() => setOpen(true), 500);

    return () => {
      window.removeEventListener('click', handleOutsideClick);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [closeModal]);

  return (
    <Modal close={closeModal}>
      <ModalWrapperBackdrop>
        <ModalWrapperContainer
          className={open ? 'open' : null}
          mobileBottom={mobileBottom}
          fitHeight={fitHeight}
          maxWidth={maxWidth}
          ref={modalRef}
          width={width}>
          <ScrollingContainer background={background} padding={padding} basic={basic} isOverFlow={isOverFlow}>
            <ModalWrapperBody mobileBottom={mobileBottom}>
              <div className="wrapper">
                {!hide && (
                  <Button
                    color={basic ? 'white' : redCloseBtn ? 'red' : 'black'}
                    redCloseBtn={redCloseBtn}
                    className="close-icon"
                    onClick={closeModal}
                    text="Close Modal"
                    iconLink="close"
                    iconSize="large"
                    inverted={basic}
                    type="icon"
                  />
                )}

                {mobileBottom && (
                  <CloseButton onClick={closeModal}>
                    <span>&#10005;</span>
                  </CloseButton>
                )}
                {children}
              </div>
            </ModalWrapperBody>
          </ScrollingContainer>
        </ModalWrapperContainer>
      </ModalWrapperBackdrop>
    </Modal>
  );
};

ModalWrapper.defaultProps = {
  closeModal: () => null,
  mobileBottom: false,
  redCloseBtn: false,
  isOverFlow: false,
  fitHeight: false,
  background: '',
  basic: false,
  maxWidth: 0,
  hide: false,
  padding: '',
  width: 0,
};

ModalWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  background: PropTypes.string,
  mobileBottom: PropTypes.bool,
  redCloseBtn: PropTypes.bool,
  isOverFlow: PropTypes.bool,
  maxWidth: PropTypes.number,
  closeModal: PropTypes.func,
  padding: PropTypes.string,
  fitHeight: PropTypes.bool,
  width: PropTypes.number,
  basic: PropTypes.bool,
  hide: PropTypes.bool,
};

export default ModalWrapper;
